import { assignmentDecision, getAssignedValue, deflateModelVariables, getAccessories, getProductDescription } from '.';
import { getLanguages } from '../services';

export const getTransformedProducts = ( cartItems, products, authType, currentNode, properties=undefined, isReadyAssembled=false,
  assemblyType, supercodeIdentified) => {

  const cartProducts = authType !== 'Cbol' ? cartItems : cartItems.map( item => {
    if ( item.configuration && item.configuration.bomComponents && item.configuration.bomComponents.length ) {
      item.children = item.configuration.bomComponents.map( c => products[c.component] );
    } else {
      item.children = getAccessories( item ).map( accessoryCode => products[accessoryCode] );
    }
    return item;
  } );

  const transformedProducts = cartProducts.map( product => {
    let isReadyAssembledInCbol = false;
    if(!isReadyAssembled)
    isReadyAssembledInCbol = properties !== undefined ?  getIsReadyAssembledInCbol( properties, product.materialName ) : getCustomProperties( product.materialName, currentNode );
    const superCode = supercodeIdentified && supercodeIdentified.data ? supercodeIdentified.data.filter( s => s.variantId == product.name ).firstOrDefault()?.superCode : null;
    const transformedProduct = getTransformedProduct(product, products, authType, isReadyAssembled, isReadyAssembledInCbol, assemblyType, superCode);
    //update properties with additional properties from the DB
    if( product.additionalProducts ){
     transformedProduct.additionalProducts = [...getTransformedProducts( product.additionalProducts.map( c => {  return {...c,amount: product.amount } }), 
      products, authType, currentNode, properties, isReadyAssembled, assemblyType, supercodeIdentified )];
    }
    if(authType === 'PartnerHub'){
      product.properties.map( p => transformedProduct.properties[p?.name]=p.value );
      product.assignments.map( c => transformedProduct.properties[c.name]= c.value );
      if( product.filterSelectors ){
        product.filterSelectors.map( filter  => {
        const selectedValue = filter.values.find( value => value.isSelected ) ? filter.values.find( value => value.isSelected ) : filter.values.firstOrDefault(value => value.isAssignable);
		//Excluding filters not available for user
        if ( selectedValue && filter.properties.Show && filter.name != 'DO NOT DISPLAY') {
          transformedProduct.properties[filter.identifier ]= selectedValue.name ;
        }
        } )
      }
    }
    return transformedProduct;
  } );
  return transformedProducts;
};

const getTransformedProduct = (product, products, authType, isReadyAssembled, isReadyAssembledInCbol, assemblyType, supercodeIdentified)=>{
  const transformedProduct = { 
    title: product.code,
    properties: {
      ProductCode: product.code,
      ProductDesc: getProductDescription(product),
      Quantity: product.amount || 1,
      Alias: isReadyAssembled || product.superCode ? product.superCode || supercodeIdentified : null,
      SelectionType: isReadyAssembled || product.superCode || isReadyAssembledInCbol || (assemblyType === 'ReadyAssembled') ? 'ReadyAssembled':'SelfAssembly',
      ListPrice: product && product.listPrice || 0.0,
      NetPrice: product && product.netPrice || 0.0
    }, 
  };
  if( product.configuration ) {
    const lang = getLanguages().first();
    const accessories = deflateModelVariables( product.configuration.model );
    const userAssignedAccessories = accessories.filter( accessory => 
      assignmentDecision( product.configuration.productModelType, lang )( accessory ) && getAssignedValue( accessory ) !== product.configuration.product.name
    );
    transformedProduct.children = [];
   userAssignedAccessories.map( accessory => {
      var accessoryName = accessory.assignedValue.name; 
      var accessoryProduct = product.children && product.children.firstOrDefault( c => c && c.name === accessoryName );
     if(products && products[accessoryName]){
     const acc = {
        title: products[accessoryName].code,
        properties: {
          Quantity: product.amount || 1, 
          AccessoryCode: products[accessoryName].code,
          AccessoryDesc: getProductDescription( products[accessoryName] ) || ( accessoryProduct && accessoryProduct.description )|| accessoryName,
          AccessorySapLevel: accessory.sapLevel || 1,
          AccessoryParent: accessory.fullyQualifiedName,
          AccessoryParentComponent: product.configuration.materialKey,
          ListPrice: accessoryProduct && accessoryProduct.listPrice || 0.0,
          NetPrice: accessoryProduct && accessoryProduct.netPrice || 0.0
        }
      }
      if(authType === 'PartnerHub'){
        products[accessoryName].properties.map( p => acc.properties[p.name]=p.value );
      }
      if (acc ){
        transformedProduct.children.push(acc)
      }
   
      return acc;
    }
    } ) ;
    if(product.configuration.bomComponents){
      const wiringDiagramDetails = product.configuration.bomComponents.filter( component => {
        return userAssignedAccessories.indexOf( component.component ) === -1 && component.itemNumber >= 9000
        });
      const missingBomItems = product.configuration.bomComponents.filter( isComponentInUserAssigned( userAssignedAccessories )).filter( acc => wiringDiagramDetails.indexOf( acc ) === -1 );
      if(missingBomItems.length > 0){
        const accessoryTobeAdded = missingBomItems.map(accessory => { 
          const acc = {
            title: accessory.component,
            properties: {
              Quantity: product.amount || 1, 
              AccessoryCode: accessory.component,
              AccessoryDesc: getProductDescription( products[accessory.component] ),
              AccessorySapLevel: accessory.sapLevel || 1,
              AccessoryParent: accessory.component,
              AccessoryParentComponent: product.configuration.materialKey
            }
          }
          if(authType === 'PartnerHub'){
            products[accessory.component].properties.map( p => acc.properties[p.name]=p.value );
          }
          return acc;
        });
        accessoryTobeAdded.forEach(function(accessory){
          if(accessory){
          transformedProduct.children.push(accessory);
          }
        })
      }
    }else{
      const missingBomItems = product.configuration.assignments.filter(assign => assign.key === null).map(assign => {return assign.value});
      for(let missingBomItem of missingBomItems){
        const accessoryTobeAdded = {
          title: products[missingBomItem].code,
          properties: {
            Quantity: product.amount || 1, 
            AccessoryCode: products[missingBomItem].code,
            AccessoryDesc: products[missingBomItem].description,
            AccessorySapLevel: products[missingBomItem].sapLevel || 1,
            AccessoryParent: products[missingBomItem].code,
            AccessoryParentComponent: product.configuration.materialKey
          }
        };
        if(authType === 'PartnerHub'){
          products[missingBomItem].properties.map( p => accessoryTobeAdded.properties[p.name]=p.value );
        }
        if(accessoryTobeAdded){
        transformedProduct.children.push(accessoryTobeAdded);
        }
      }
    }
  }
  return transformedProduct;
}

const isComponentInUserAssigned = (userAssignedAccessories) => {
  return function(component){
    return userAssignedAccessories.filter(function(accessory){
      return accessory.assignedValue.name == component.component
    }).length == 0;
  }
};

const getIsReadyAssembledInCbol = ( properties, materialName ) => {
  if( properties && properties.enableReadyAssembledInCbol ){
    return properties.enableReadyAssembledInCbol.any(x=>x===materialName);
  } else {
    return false;
  }
}

const getCustomProperties = ( materialName, currentNode ) => {
  if( currentNode.children.length > 0 ) {
    for( const [key,val] of Object.entries( currentNode.children ) ) {
      const customProperties = val.isSelector && val.customProperties ? getIsReadyAssembledInCbol(val.customProperties, materialName) : getCustomProperties( materialName,val );
      if(customProperties ){
        return customProperties;
      }
    }
  }else{
    return getIsReadyAssembledInCbol(currentNode.customProperties, materialName);
  }
}
export const getCartItems = (items)=>{
  let newCartItems = [];
  items.forEach(item => {
    if(item.isSuperConfiguration){
      item.additionalProducts.forEach(prod => {
        newCartItems.push(prod);
      })
    }else{
      newCartItems.push(item);
    }
  });
  return newCartItems;
}
